import DoneIcon from '@mui/icons-material/Done'
import ErrorIcon from '@mui/icons-material/Error'
import CircularProgress from '@mui/material/CircularProgress'
import MuiIconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { styled } from '@mui/system'
import { Job } from 'entities/Job'

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  width: 20,
  marginRight: theme.spacing(0.5),
  alignItems: 'center',
  justifyContent: 'center',
}))

const IconButton = styled(MuiIconButton)({
  '&:hover': {
    backgroundColor: 'transparent',
  },
})

interface InnerIconProps {
  type: ReturnType<Job['statusType']>
}
const InnerIcon = ({ type }: InnerIconProps) => {
  switch (type) {
    case 'completed':
      return <DoneIcon color="primary" fontSize="small" />
    case 'failed':
      return <ErrorIcon color="error" fontSize="small" />
    case 'processing':
      return <CircularProgress size={14} color="secondary" />
  }
}

interface Props {
  job: Job
  message: string
}
const JobStatusIcon = ({ job, message }: Props) => {
  const type = job.statusType()

  return (
    <Container>
      <Tooltip arrow title={message} followCursor placement="top">
        <IconButton disabled={!message} size="small">
          <InnerIcon type={type} />
        </IconButton>
      </Tooltip>
    </Container>
  )
}

export default JobStatusIcon
